<template>
	<div>
		<AttachmentSection :files='files' />

		<v-card rounded>
			<v-card-text v-html='text' />
		</v-card>
	</div>
</template>

<script>
import ContentService from '@/services/ContentService'
import AttachmentSection from '@/components/base/AttachmentSection'

export default {
	name: 'Distributors',

	components: {
		AttachmentSection
	},

	data() {
		return {
			text: '',
			files: []
		}
	},

	async created() {
		const { contentId } = this.$router.currentRoute.meta

		const {
			text,
			files
		} = await ContentService.get(contentId)

		this.text = text
		this.files = files
	},
}
</script>
